import { Injectable } from '@angular/core';

import { ScreenFieldModel } from '@models/module/fields/main';
import { GridSearchEntityInstance, GridViewModel } from '@models/module/grid';
import { DataCard, DataCardViewPart } from '@models/module/main';
import { Currency, CurrencyFn } from '@models/system';
import { HttpService } from '@shared/services';

@Injectable({ providedIn: 'root' })
export class DataCardsViewService {
  constructor(private httpService: HttpService) {}

  getScreenFields(screenType: number) {
    return this.httpService.post<GridViewModel<ScreenFieldModel[]>>(
      `_api/ScreenFields/Search?screenType=${screenType}`,
      {},
      { useLoader: false },
    );
  }

  getDataCard(fields: ScreenFieldModel[], row: GridSearchEntityInstance, currency: Currency | CurrencyFn): DataCard {
    const parts = (fields || []).map(field => {
      const part = new DataCardViewPart(field.id, field);
      part.value = row[field.systemFieldName] || row[field.id];
      part.currency = typeof currency == 'function' ? currency(row) : currency;
      return part;
    });
    return {
      ...row,
      parts,
      is_closed_state: row.state_type == 'Closed',
      is_archived_state: row.state_type == 'Archived',
    } as DataCard;
  }
}
